<template>
  <div class="sign-in">
    <md-card md-with-hover v-cloak>
      <md-card-media>
        <img class="image" src="/static/maxima-logo.svg"/>
      </md-card-media>

      <md-card-header>
        <div class="md-title">Maxima-Online</div>
        <translate tag="div" v-if="$route.query.redirect">You need to login first.</translate>
        <translate tag="div" v-else class="md-subhead">Please sign-in</translate>
      </md-card-header>

      <md-card-content>
        <form @keyup="keymonitor" novalidate @submit.stop.prevent="submit">
          <md-input-container :class="{'md-input-invalid': !validEmail(user.email) && emailDirty && formSubmitted }">
            <translate tag="label">E-mail</translate>
            <md-input id="sign-in-email" @input.native="inputEmail()" type="email" v-model="user.email"></md-input>
            <span class="md-error"><translate>Invalid e-mail</translate></span>
          </md-input-container>

          <md-input-container md-has-password>
            <translate tag="label">Password</translate>
            <md-input id="sign-in-password" @input.native="inputPass()" v-model="user.password" type="password"></md-input>
            <span class="forgot"><router-link to="/reset"><translate>Forgot your password?</translate></router-link></span>
          </md-input-container>
        </form>
      </md-card-content>

      <md-card-actions>
        <md-spinner v-if="spinning" :md-size="20" md-indeterminate></md-spinner>
        <router-link tag="button" to="/sign-up" class="md-primary md-button"><translate>Sign-up</translate></router-link>
        <md-button id="login-button" @click.native="login" class="md-primary md-raised"><translate>Sign-in</translate></md-button>
      </md-card-actions>

      <md-snackbar md-position="bottom center" ref="snackbar" :md-duration="4000">
        <span><md-icon>warning</md-icon> {{ snackbarMsg }}</span>
        <md-button class="md-accent" @click.native="$refs.snackbar.close()"><translate>Close</translate></md-button>
      </md-snackbar>

    </md-card>
  </div>
</template>

<script>
import auth from '../../auth'
import validator from 'validator'

export default {
  name: 'sign-in',
  data () {
    return {
      spinning: false,
      snackbarMsg: '',
      user: {
        email: '',
        password: ''
      },
      emailDirty: false,
      formSubmitted: false,
      passDirty: false
    }
  },
  created () {
    this.snackbarMsg = this.$gettext('Invalid E-mail or Password')
  },
  methods: {
    keymonitor (event) {
      if (event.key === 'Enter') {
        this.login()
      }
    },
    login () {
      this.emailDirty = true
      this.formSubmitted = true
      this.passDirty = true
      if (this.validEmail(this.user.email)) {
        this.spinning = true

        auth.login(this.user.email, this.user.password)
          .then(() => {
            this.$router.replace(this.$route.query.redirect || '/')
            this.user.email = ''
            this.user.password = ''
            this.spinning = false
          })
          .catch((err) => {
            let msg
            if (err === 'invalid') {
              msg = this.$gettext('Invalid E-mail or Password')
            } else if (err === 'notactiv') {
              msg = this.$gettext('Account is not yet activated')
            } else {
              msg = this.$gettext('Unable to connect to the server. Please, try again later.')
            }
            this.snackbarMsg = msg
            this.$refs.snackbar.open()
            this.spinning = false
          })
      }
    },
    validEmail (email) {
      return validator.isEmail(email)
    },
    inputEmail () {
      this.emailDirty = true
      this.formSubmitted = false
      this.spinning = false
    },
    inputPass () {
      this.passDirty = true
      this.formSubmitted = false
      this.spinning = false
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.query.redirect) {
      console.log('redirecting to ', to.query.redirect)
      next({
        path: to.query.redirect
      })
    } else {
      next()
    }
  }
}
</script>

<style scoped>
[v-cloak] {
  display: none!important;
}
.sign-in {
  width: 25rem;
  margin: 5em auto;
}
.image {
  width: 100% !important;
  padding: 30px 30px 10px 30px;
}
.forgot {
  position: absolute;
  bottom: -22px;
  font-size: 0.9em;
  left: 0;
  /*color: gray !important;*/
}
</style>



// WEBPACK FOOTER //
// src/components/login/SignIn.vue